import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import {
  convertArrayToString,
  customTextColor,
  formatDate,
  formatText,
  formatTime,
} from "../../../utils/const";
import { useEffect, useState } from "react";
import profile_image from "../../../assets/images/ajit_image.jpeg";
import { IoIosAdd } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { PiBuildingLight, PiUserLight } from "react-icons/pi";
import { CiMobile3 } from "react-icons/ci";
import { PiMailboxLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  accepteSubmissionTracker,
  getOneSubmissionTracker,
  updateActionSubmissiontracker,
} from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import AddCandidateListDrawer from "./AddCandidateListDrawer";
import AddCandidateInRequirementDrawer from "./AddCandidateInRequirementDrawer";
import JobTrackerCandidateCard from "../../../components/common/JobTrackerCandidateCard";
import CandidateFeedbackDrawer from "./CandidateFeedbackDrawer";
import AddCandidateDrawerResumeProfile from "./AddCandidateDrawerResumeProfile";
import { getProfile } from "../../../redux/profile/profileSlice";
import RequirementTrackerCandidateView from "./RequirementTrackerCandidateView";
import { allSkill } from "../../../redux/common/skillSlice";
import { display } from "@mui/system";
import CandidatePostFeedbackDrawer from "./CandidatePostFeedbackDrawer";
import CandidatePostFeedbackBenchSalesDrawer from "./CandidatePostFeedbackBenchSalesDrawer";
import CandidatePostFeedbackRecruiterDrawer from "./CandidatePostFeedbackRecruiterDrawer";
import Signature from "../../../components/common/Signature";
import RequirementPostDrawer from "../../Requirement/RequirementPostDrawer";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { allLocation } from "../../../redux/common/locationSlice";

const SubmissionTrackerViewDrawer = ({ handleClose, show, row, index }) => {
  const [viewData, setViewData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [submissionRes, setSubmissionRes] = useState({});
  const [candidateListDetails, setCandidateListDetails] = useState({});
  const [open, setOpen] = useState(false);
  const [openAccept, setOpenAccept] = useState(false);

  const [btn1, setBtn1] = useState("");
  const [openAction, setOpenAction] = useState(false);
  const [showAdd, setShow] = useState(false);
  const [actionName, setActionName] = useState("");
  const [isChangeAction, setIsChangeAction] = useState(false);
  const [showCandidate, setShowCandidate] = useState(false);
  const handleCloseShowCandidate = () => setShowCandidate(false);
  const handleShowCandidate = () => setShowCandidate(true);
  const [showCandidateResume, setShowCandidateResume] = useState(false);
  const handleCloseShowCandidateResume = () => setShowCandidateResume(false);
  const handleShowCandidateResume = () => setShowCandidateResume(true);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showPostRequirement, setShowPostRequirement] = useState(false);
  const handleCloseShowPostRequirement = () => setShowPostRequirement(false);
  const handleShowPostRequirement = () => setShowPostRequirement(true);

  const [showFeedback, setShowFeedback] = useState(false);
  const [showAddFeedback, setShowAddFeedback] = useState(false);
  const [showAddFeedbackBenchSales, setShowAddFeedbackBenchSales] =
    useState(false);
  const [showAddFeedbackRecruiter, setShowAddFeedbackRecruiter] =
    useState(false);

  const handleCloseShowFeedback = () => setShowFeedback(false);
  const handleShowFeedback = () => setShowFeedback(true);
  const handleCloseShowAddFeedback = () => setShowAddFeedback(false);
  const handleShowAddFeedback = () => setShowAddFeedback(true);
  const handleCloseShowAddFeedbackBenchSales = () =>
    setShowAddFeedbackBenchSales(false);
  const handleShowAddFeedbackBenchSales = () =>
    setShowAddFeedbackBenchSales(true);

  const handleCloseShowAddFeedbackRecruiter = () =>
    setShowAddFeedbackRecruiter(false);
  const handleShowAddFeedbackRecruiter = () =>
    setShowAddFeedbackRecruiter(true);

  const [showCandidateView, setShowCandidateView] = useState(false);
  const handleCloseShowCandidateView = () => setShowCandidateView(false);
  const handleShowCandidateView = () => setShowCandidateView(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const viewdata = useSelector((state) => state.trackersubmission.trackerData);
  const trackerStatus = useSelector((state) => state.trackersubmission.status);
  const skillData = useSelector((state) => state.skill.data);
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location);
  const [jobStatusName, setJobStatusName] = useState("");
  const internalSubStatus = useSelector(
    (state) => state.trackersubmission.status
  );
  const oneSubmisionStatus = useSelector(
    (state) => state.trackersubmission.oneSubmisionStatus
  );
  const profile = useSelector((state) => state.profile.data);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionDetails"))
  );

  const [dataview, setDataview] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalSubmissionDetailsWhichView"))
  );

  useEffect(() => {
    dispatch(getProfile());
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  // const getPreferLocationNames = (preferLocation) => {
  //   return preferLocation
  //     ?.map(
  //       (id) =>
  //         locations?.data?.locations?.find((location) => location.id === id)
  //           ?.name
  //     ) // Map IDs to names
  //     ?.filter(Boolean) // Remove any undefined values if IDs don't match
  //     ?.join(", "); // Join names with a comma and space
  // };

  const getPreferLocationNames = (preferLocation) =>
    (preferLocation || [])
      .map(
        (id) => locations?.data?.locations?.find((loc) => loc.id === id)?.name
      )
      .filter(Boolean) // Removes undefined or falsy
      .join(", ");

  useEffect(() => {
    if (row) {
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
    }
  }, [row]);

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalSubmissionDetails",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    setViewData(viewdata?.requirements);
  }, [viewdata]);

  useEffect(() => {
    if (trackerStatus === "add_candidate_to_submission") {
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleCloseShowCandidate();
      handleCloseShow();
    }
  }, [trackerStatus, row]);

  useEffect(() => {
    if (oneSubmisionStatus === "accept_submission_from_bdm") {
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleOpenAccept();
    }
  }, [oneSubmisionStatus, row]);

  const getSkillNames = (skills) => {
    return skills
      ?.map(
        (id) => skillData?.locations?.find((skill) => skill.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenAccept = () => {
    setOpenAccept(true);
  };

  const handleCloseActionChange = () => {
    setOpen(false);
  };

  const handleOpenAction = () => {
    setOpenAction(true);
  };

  const handleCloseAction = () => {
    setOpenAction(false);
  };

  const handleCloseAccept = () => {
    setOpenAccept(false);
  };

  const handleOnChangeAction = (name) => {
    setActionName(name);
  };

  const handleOnClickChangeAction = () => {
    let values = {
      requirement_status: btn1,
      job_title: viewData?.job_title,
    };
    let id = viewData?.requirement_id;
    dispatch(updateActionSubmissiontracker({ values, id }));
    setIsChangeAction(true);
  };

  useEffect(() => {
    if (
      oneSubmisionStatus === "update_requirement_tracker_action" &&
      isChangeAction
    ) {
      let id = row?.requirement_id;
      dispatch(getOneSubmissionTracker(id));
      handleCloseActionChange();
      handleCloseAction();
      setIsChangeAction(false);
    }
  }, [oneSubmisionStatus]);

  useEffect(() => {
    if (viewData) {
      setBtn1(viewData?.requirement_status);
      setJobStatusName(viewData?.requirement_status);
    }
  }, [viewData, oneSubmisionStatus]);

  const whichStatus = (value) => {
    let status;
    if (value === "Active") {
      status = "Open";
    } else if (value === "On Hold") {
      status = "Hold";
    } else if (value === "Closed") {
      status = "Close";
    }
    return status;
  };

  const handleSelect = (text) => {
    setBtn1(text);
    handleOpen();
  };

  const handleOnClickCandidateAdd = (candidate) => {
    handleShow();
    setCandidateListDetails(candidate);
  };

  const handleAddCandidate = () => {
    if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
      handleShowCandidateResume();
    } else {
      handleShowCandidate();
    }

    localStorage.setItem(
      "internalSubmissionDetails",
      JSON.stringify({ row, type: "view" })
    );
    localStorage.setItem(
      "internalSubmissionDetailsWhichView",
      JSON.stringify({ type: "view", row })
    );
    // setSubmisionRow(row);
    handleCloseAccept();
  };

  const handleOnAcceptrequirement = () => {
    let userData = {
      requirement_id: row?.requirement_id,
    };
    dispatch(accepteSubmissionTracker(userData));
  };

  const handleOnClickPostJob = () => {
    handleShowPostRequirement();
    handleCloseAccept();
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        // padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {viewData?.requirement_created_by === "IT_RECRUITER" ? (
          <>
            <Grid
              container
              className={styles.verification_phase}
              sx={{
                backgroundColor: "#fff",
                padding: "0",
                marginBottom: "0",
                width: "97%",
              }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor, border: "none !important" }}
              >
                <Typography sx={{ marginLeft: "0 !important" }}>
                  Submitted on:{" "}
                  <b>
                    {viewData?.created_at !== undefined &&
                      formatDate(viewData?.created_at)}
                    {", "}
                    {viewData?.created_at !== undefined &&
                      formatTime(viewData?.created_at)}
                  </b>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor }}
              >
                <Typography>
                  Submitted to: <b>{viewData?.bdm_name}</b>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                lg={4}
                sx={{ color: customTextColor }}
              >
                <Typography>
                  Role: <b>Business Development Manager</b>
                </Typography>
              </Grid>
            </Grid>

            <RxCross2
              style={{
                fontSize: "22px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </>
        ) : (
          <Box className={styles.bdmDetails}>
            <span>
              <Typography>
                Job ID: <b> {viewData?.requirement_id}</b>
              </Typography>
              <Typography>
                Max Submission:{" "}
                <b> {viewData?.max_no_of_submissions_from_team}</b>
              </Typography>
              {/* <Typography>
                Required Submissions in: <b> {viewData?.submission_deadline}</b>
              </Typography> */}
            </span>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                // flexDirection: "column",
              }}
            >
              <Typography>
                Date:{" "}
                <b>
                  {" "}
                  {viewData?.created_at !== undefined &&
                    formatDate(viewData?.created_at)}
                  {", "}
                  {viewData?.created_at !== undefined &&
                    formatTime(viewData?.created_at)}
                </b>
              </Typography>
              <RxCross2
                style={{
                  fontSize: "22px",
                  cursor: "pointer",
                  color: customTextColor,
                  marginBottom: "20px",
                }}
                onClick={handleClose}
              />
            </span>
          </Box>
        )}
      </Offcanvas.Header>
      <Offcanvas.Body style={{ padding: "0" }}>
        {oneSubmisionStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 230,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : (
          <Box
            sx={{ margin: "0 20px 20px !important" }}
            className={styles.add_structure}
          >
            {viewData?.requirement_created_by === "IT_RECRUITER" && (
              <Grid
                container
                className={styles.candidates_name}
                sx={{ marginBottom: "14px" }}
              >
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Grid
                    container
                    className={styles.requirement_details_view}
                    sx={{ color: customTextColor, backgroundColor: "#edeeef" }}
                  >
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        <Box sx={{ marginBottom: "0 !important" }}>
                          <PiUserLight
                            style={{ fontSize: "25px", color: customTextColor }}
                          />
                          <Typography>
                            Received from: <b>{viewData?.bdm_name}</b>
                          </Typography>
                        </Box>

                        {/* <Box sx={{ marginBottom: "0 !important" }}>
                          <PiMailboxLight
                            style={{ fontSize: "25px", color: customTextColor }}
                          />
                          <Typography>
                            Work Email ID : <b>{viewData?.bdm_email}</b>
                          </Typography>
                        </Box> */}
                      </span>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        {/* <Box>
                          <PiBuildingLight
                            style={{ fontSize: "24px", color: customTextColor }}
                          />
                          <Typography>
                            Company Name: <b>{viewData?.company_name}</b>
                          </Typography>
                        </Box>

                        <Box sx={{ marginBottom: "0 !important" }}>
                          <CiMobile3
                            style={{ fontSize: "25px", color: customTextColor }}
                          />
                          <Typography>
                            Phone No: <b>{viewData?.bdm_mobile_no}</b>
                          </Typography>
                        </Box> */}
                        <Box sx={{ marginBottom: "0 !important" }}>
                          <PiMailboxLight
                            style={{ fontSize: "25px", color: customTextColor }}
                          />
                          <Typography>
                            Work Email ID : <b>{viewData?.bdm_email}</b>
                          </Typography>
                        </Box>
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Box className={styles.profile_submit} sx={{ padding: "0" }}>
              <Box>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    <Typography sx={{ marginTop: "10px !important" }}>
                      <b>
                        {viewData?.requirement_id}, {viewData?.job_title} with{" "}
                        {/* {viewData?.experience} Years’ Experience at{" "} */}
                        {/* {viewData?.experience} Years’ Experience{" "} */}
                        {/* {getPreferLocationNames(viewData?.location)},{" "} */}
                      </b>
                    </Typography>
                    <Typography>
                      <b>{getPreferLocationNames(viewData?.location)}, </b>
                    </Typography>
                    <Typography>
                      <b>
                        {viewData?.duration} {viewData?.duration ? "Month" : ""}{" "}
                        {convertArrayToString(viewData?.requirement_type)}
                        {/* {viewData?.job_type} */}
                      </b>
                    </Typography>
                    <Typography>
                      <b>
                        From ${viewData?.rate}
                        {viewData?.requirement_type?.includes("full_Time")
                          ? "K Yearly"
                          : " Hourly"}
                      </b>
                    </Typography>
                    <Typography>
                      <b> {viewData?.mode_of_interview} Interview</b>
                    </Typography>
                  </span>

                  <span
                    className={styles.phase2}
                    style={{
                      // marginTop: "10px",
                      alignSelf: "start",
                      textAlign: "center",
                    }}
                  >
                    <a style={{ fontSize: "30px" }}>
                      <b>{viewData?.no_of_opening || 0}</b>
                    </a>
                    <Typography>
                      <b> Job Openings</b>
                    </Typography>
                  </span>
                </span>
              </Box>
            </Box>

            <Box className={styles.candidate_text}>
              {" "}
              <span>
                <Typography sx={{ padding: "0 !important", marginTop: "20px" }}>
                  <b>Job Description</b>
                </Typography>
                <Typography sx={{ padding: "0 !important" }}>
                  {viewData?.job_description?.split("\n")?.map(
                    (line, index) =>
                      line?.trim() && (
                        <p
                          key={index}
                          style={{
                            marginTop: "7px",
                            padding: "0",
                          }}
                        >
                          {line}
                        </p>
                      )
                  )}
                </Typography>
                <Typography sx={{ padding: "0 !important", marginTop: "20px" }}>
                  <b>Mandatory Skills</b>
                </Typography>
                <Typography sx={{ padding: "0 !important", marginTop: "7px" }}>
                  {getSkillNames(viewData?.mandatory_skills)}
                </Typography>
              </span>
            </Box>
            <Box
              sx={{
                marginTop: "40px",
                padding: "10px 0",
                borderBottom: "1px solid #f2f2f2",
              }}
            >
              <Signature
                name={
                  viewData?.created_by_recruiter_details?.profiles[0]?.fullName
                }
                role={formatText(
                  viewData?.created_by_recruiter_details?.profiles[0]?.role
                )}
                company_name={viewData?.company_details?.name}
                email={
                  viewData?.created_by_recruiter_details?.profiles[0]?.email
                }
                mobile_no={
                  viewData?.created_by_recruiter_details?.profiles[0]?.mobileNo
                }
              />
            </Box>
            <Box className={styles.mass_new_structure}>
              <Box
                className={styles.new_header_text}
                sx={{ marginTop: "30px" }}
              >
                <Typography sx={{ padding: "0 !important" }}>
                  {viewData?.bdm_requirement_accepted_by_recruiter === false
                    ? "Note: Submission button will be enabled after job acceptance"
                    : "Submissions"}
                </Typography>
                {profile?.profile?.role !== "BENCH_SALES_RECRUITER" &&
                  (viewData?.requirement_created_by === "IT_RECRUITER" ? (
                    <button onClick={handleAddCandidate}>
                      Add Submission
                      <IoIosAdd
                        style={{ fontSize: "25px", marginLeft: "5px" }}
                      />
                    </button>
                  ) : viewData?.bdm_requirement_accepted_by_recruiter ===
                    false ? (
                    <button
                      onClick={handleOnAcceptrequirement}
                      style={{ padding: "8px 20px" }}
                    >
                      {oneSubmisionStatus === "loading" ? "Loading" : "Accept"}
                    </button>
                  ) : (
                    <button onClick={handleAddCandidate}>
                      Add Submission
                      <IoIosAdd
                        style={{ fontSize: "25px", marginLeft: "5px" }}
                      />
                    </button>
                  ))}
              </Box>

              {internalSubStatus === "loading" ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 230,
                  }}
                >
                  <CircularProgress size={30} color="info" />
                </Box>
              ) : (
                <Box className={styles.requiter_profile_section}>
                  {viewData?.submissions_for_requirement?.map((res, index) => {
                    return (
                      <JobTrackerCandidateCard
                        key={index}
                        name={res?.full_name}
                        res={res}
                        row={row}
                        type="view"
                        viewData={viewData}
                        handleShowFeedback={handleShowFeedback}
                        handleShowCandidateView={handleShowCandidateView}
                        setSubmissionRes={setSubmissionRes}
                        getWorkAuthorization={getWorkAuthorization}
                        getPreferLocationNames={getPreferLocationNames}
                      />
                    );
                  })}
                </Box>
              )}
            </Box>
            <Box className={styles.requiter_profile_section}></Box>
            {internalSubStatus !== "loading" && (
              <Box className={styles.add_candidate_btns}>
                <Box className={styles.add_back_btns}>
                  <button
                    // onClick={() => navigate("/submision-tracker")}
                    onClick={handleClose}
                    style={{
                      border: "1.5px solid #4287f5",
                      marginRight: "10px",
                      padding: "4.5px 10px ",
                    }}
                  >
                    <IoIosArrowRoundBack
                      style={{ fontSize: "25px", color: "#4287f5" }}
                    />
                  </button>
                </Box>

                <div className="btn-group">
                  <button
                    type="button"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{
                      color: "black",
                      width: "7rem",
                      border: "1.5px solid #4287f5",
                      padding: "6px 10px",
                    }}
                    disabled={
                      viewData?.is_accepted_by_bdm !== "REJECTED" ||
                      profile?.profile?.role === "BENCH_SALES_RECRUITER"
                    }
                  >
                    {whichStatus(btn1)}
                  </button>
                  <div className="dropdown-menu">
                    <a
                      className="dropdown-item"
                      style={
                        jobStatusName === "Active"
                          ? {
                              backgroundColor: "#fff",
                              pointerEvents: "none",
                              opacity: "0.5",
                              cursor: "not-allowed ",
                            }
                          : { backgroundColor: "#fff" }
                      }
                      onClick={() => handleSelect("Active")}
                    >
                      Open
                    </a>
                    <a
                      className="dropdown-item"
                      style={
                        jobStatusName === "On Hold"
                          ? {
                              backgroundColor: "#fff",
                              pointerEvents: "none",
                              opacity: "0.5",
                              cursor: "not-allowed ",
                            }
                          : { backgroundColor: "#fff" }
                      }
                      onClick={() => handleSelect("On Hold")}
                    >
                      Hold
                    </a>
                    <a
                      className="dropdown-item"
                      style={
                        jobStatusName === "Closed"
                          ? {
                              backgroundColor: "#fff",
                              pointerEvents: "none",
                              opacity: "0.5",
                              cursor: "not-allowed ",
                            }
                          : { backgroundColor: "#fff" }
                      }
                      onClick={() => handleSelect("Closed")}
                    >
                      Close
                    </a>
                  </div>
                </div>
              </Box>
            )}
          </Box>
        )}

        <Dialog
          fullScreen={fullScreen}
          open={openAction}
          // onClose={handleCloseAction}
          maxWidth="md"
          aria-labelledby="responsive-dialog-title"
          fullWidth={true}
        >
          <Box>
            <DialogContent sx={{ display: "flex", justifyContent: "center" }}>
              <Box>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios1"
                    value="Active"
                    checked={actionName === "Active"}
                    onChange={() => handleOnChangeAction("Active")}
                    disabled={
                      viewData?.is_accepted_by_bdm !== "REJECTED" ||
                      profile?.profile?.role === "BENCH_SALES_RECRUITER"
                    }
                  />
                  <label class="form-check-label" htmlFor="exampleRadios1">
                    Open
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios2"
                    value="On Hold"
                    checked={actionName === "On Hold"}
                    onChange={() => handleOnChangeAction("On Hold")}
                  />
                  <label class="form-check-label" htmlFor="exampleRadios2">
                    Hold
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios3"
                    value="Closed"
                    checked={actionName === "Closed"}
                    onChange={() => handleOnChangeAction("Closed")}
                  />
                  <label class="form-check-label" htmlFor="exampleRadios3">
                    Close
                  </label>
                </div>
              </Box>
            </DialogContent>
            <Box>
              <Box className={styles.adding_internal_btns}>
                <button
                  sx={{ backgroundColor: "#2d73b5" }}
                  // onClick={handleOnClickStatusChange}
                  onClick={handleOpen}
                >
                  Change
                </button>
                <button
                  sx={{ backgroundColor: "#97B6F1" }}
                  onClick={handleCloseAction}
                >
                  Cancel
                </button>
              </Box>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          fullScreen={fullScreen}
          open={open}
          maxWidth="sm"
          aria-labelledby="responsive-dialog-title"
          fullWidth={true}
        >
          <Box>
            <DialogTitle
              id="responsive-dialog-title"
              sx={{ textAlign: "center" }}
            >
              <b>Job Action Change</b>
            </DialogTitle>
            <DialogContent sx={{ textAlign: "center" }}>
              Are you sure you want to change action to {whichStatus(btn1)}
            </DialogContent>
            <Box>
              <Box className={styles.adding_internal_btns}>
                <button
                  sx={{ backgroundColor: "#2d73b5" }}
                  // onClick={handleOnClickStatusChange}
                  onClick={handleOnClickChangeAction}
                >
                  Yes
                </button>
                <button
                  sx={{ backgroundColor: "#97B6F1" }}
                  onClick={handleCloseActionChange}
                >
                  No
                </button>
              </Box>
            </Box>
          </Box>
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          open={openAccept}
          onClose={handleCloseAccept}
          maxWidth="sm"
          aria-labelledby="responsive-dialog-title"
          fullWidth={true}
        >
          <Box>
            <DialogTitle
              id="responsive-dialog-title"
              sx={{ textAlign: "center" }}
            >
              <b>What On Your Mind</b>
            </DialogTitle>
            <DialogContent></DialogContent>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ backgroundColor: "#2d73b5" }}
                onClick={handleOnClickPostJob}
              >
                Post Job
              </button>
              <button
                sx={{ backgroundColor: "#97B6F1" }}
                onClick={handleAddCandidate}
              >
                Add Submision
              </button>
            </Box>
          </Box>
        </Dialog>
      </Offcanvas.Body>

      <AddCandidateListDrawer
        handleShow={handleShowCandidate}
        handleClose={handleCloseShowCandidate}
        show={showCandidate}
        row={row}
        handleShowAdd={handleOnClickCandidateAdd}
        setIsEdit={setIsEdit}
      />

      <AddCandidateDrawerResumeProfile
        handleShow={handleShowCandidateResume}
        handleClose={handleCloseShowCandidateResume}
        show={showCandidateResume}
        row={row}
        handleShowAdd={handleOnClickCandidateAdd}
      />

      <CandidateFeedbackDrawer
        handleShow={handleShowFeedback}
        handleClose={handleCloseShowFeedback}
        show={showFeedback}
        candidate={submissionRes}
        handleShowAddFeedback={handleShowAddFeedback}
        handleShowAddFeedbackBenchSales={handleShowAddFeedbackBenchSales}
        handleShowAddFeedbackRecruiter={handleShowAddFeedbackRecruiter}
      />

      <CandidatePostFeedbackDrawer
        handleShow={handleShowAddFeedback}
        handleClose={handleCloseShowAddFeedback}
        show={showAddFeedback}
        candidate={submissionRes}
        handleShowAddFeedbackBenchSales={handleShowAddFeedbackBenchSales}
      />

      <CandidatePostFeedbackBenchSalesDrawer
        handleShow={handleShowAddFeedbackBenchSales}
        handleClose={handleCloseShowAddFeedbackBenchSales}
        show={showAddFeedbackBenchSales}
        candidate={submissionRes}
        handleShowAddFeedback={handleShowAddFeedback}
      />

      <CandidatePostFeedbackRecruiterDrawer
        handleShow={handleShowAddFeedbackRecruiter}
        handleClose={handleCloseShowAddFeedbackRecruiter}
        show={showAddFeedbackRecruiter}
        candidate={submissionRes}
      />

      <AddCandidateInRequirementDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={showAdd}
        row={row}
        setDataview={setDataview}
        setData={setData}
        candidateListDetails={candidateListDetails}
      />

      <RequirementTrackerCandidateView
        handleShow={handleShowCandidateView}
        handleClose={handleCloseShowCandidateView}
        show={showCandidateView}
        row={row}
        res={submissionRes}
        handleShowAdd={handleOnClickCandidateAdd}
      />
      <RequirementPostDrawer
        handleShow={handleShowPostRequirement}
        handleClose={handleCloseShowPostRequirement}
        show={showPostRequirement}
        type="republis"
        row={row}
      />
    </Offcanvas>
  );
};

export default SubmissionTrackerViewDrawer;
